import * as THREE from "three";

const EARTH_SOURCES = [
  "https://cdn.jsdelivr.net/gh/mrdoob/three.js@r160/examples/textures/planets/earth_atmos_2048.jpg",
  "https://threejs.org/examples/textures/planets/earth_atmos_2048.jpg",
  "https://unpkg.com/three@0.160.0/examples/textures/planets/earth_atmos_2048.jpg",
];

export function loadEarthTexture(onLoad: (t: THREE.Texture) => void, onFail: () => void): void {
  const loader = new THREE.TextureLoader();
  loader.setCrossOrigin("anonymous");
  let i = 0;
  const tryNext = () => {
    const src = EARTH_SOURCES[i++];
    if (!src) {
      onFail();
      return;
    }
    loader.load(
      src,
      (t) => onLoad(t),
      undefined,
      () => tryNext(),
    );
  };
  tryNext();
}
